import React from 'react';
import { Checkbox } from 'antd';

// « Ne plus afficher » checkbox, shown when the pop-up allows it (Popup.peut_masquer).
// Every modal places it where it fits its design.
export default function NeverBox({ show, checked, onChange, style }) {
  if (!show) return null;
  return (
    <div style={{ textAlign: 'center', marginTop: 8, ...style }}>
      <Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)} style={{ color: '#94a3b8', fontSize: 13 }}>
        Ne plus afficher ce message
      </Checkbox>
    </div>
  );
}
